import { useEffect, useState } from "react";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import TextArea from "../ReusableComponents/TextArea";
import { BindPostAPI } from "../services/APIConnection";
import { mainTable } from "../css/Common";
import usePrevious from "../Hook/UsePrevious";

const ReceiptMainPopup = ({ data, data1 }) => {
  const [tableData, setTableData] = useState([
    {
      itemType: "",
      itemCategoryId: "",
      itemId: "",
      quantity: "",
      rate: "",
      uomId: "",
      itemList: [], // filtered item list per row
      itemCategoryList: [],
    },
  ]);
  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const date = new Date(dateStr);
    if (isNaN(date)) return "N/A";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const [itemtype, setItemType] = useState([]);
  const [itemcategoryd, setItemCategory] = useState([]);
  const [itemd, setItemList] = useState([]);
  const previousTableData = usePrevious(tableData);
  const mstclientId = sessionStorage.getItem("MstClientId");

  useEffect(() => {
    BindReceipt();
  }, []);

  const BindReceipt = async () => {
    const requestData = {
      mstClientId: mstclientId,
    };

    const response = await BindPostAPI(requestData, "ReceiptAPI/BindReceipt");
    if (response && response.data) {
      console.log(response);
      const ItemTypes = response.data.Table1.map((item) => ({
        value: item.MstItemTypeId,
        label: item.ItemType,
      }));
      console.log("Itamedata", response.data);
      setItemType(ItemTypes);
      setItemCategory(response.data.Table2);
      setItemList(response.data.Table3);

      console.log(response.data.Table2);
      console.log(response.data.Table3);
    }
  };

  const updateTableData = async (formatted) => {
    if (JSON.stringify(previousTableData) !== JSON.stringify(formatted)) {
      const updatedTableData = [...formatted];
      for (const row of updatedTableData) {
        if (row?.itemType) {
          const filteredCategories = itemcategoryd
            .filter((item) => item.MstItemTypeId === row.itemType)
            .map((item) => ({
              value: item.MstItemCategoryId,
              label: item.ItemCategory,
            }));
          row.itemCategoryList = filteredCategories;
        }

        if (row?.itemCategoryId) {
          const filteredItems = itemd
            .filter((item) => item.MstItemCategoryId === row.itemCategoryId)
            .map((item) => ({
              value: item.MstItemId,
              label: item.ItemName,
              uom: item.UOM,
            }));
          row.itemList = filteredItems;

          const selectedItem = filteredItems.find(
            (item) => item.value === parseInt(row.itemId)
          );
          row.uomId = selectedItem?.uom || "";
        }
      }

      setTableData(updatedTableData);
    }
  };

  useEffect(() => {
    if (data1.length !== 0) {
      appendDataToTable(data1); // pass array directly
    } else {
      setTableData([
        ...tableData,
        {
          itemtype: 0,
          itemcategory: "",
          itemname: "",
          uom: "",
          quantity: "",
          itemcategoryList: [],
          itemList: [],
        },
      ]);
    }
  }, [data]);

  const appendDataToTable = (newData) => {
    let newDataArray;

    if (Array.isArray(newData)) {
      // Already an array
      newDataArray = newData;
    } else if (typeof newData === "string") {
      try {
        newDataArray = JSON.parse(newData);
      } catch (err) {
        console.error("Invalid JSON string passed to appendDataToTable", err);
        return;
      }
    } else {
      console.error(
        "appendDataToTable expected array or JSON string but got:",
        newData
      );
      return;
    }

    handleDeleteRow(0);
    setTableData([]);

    const formatted = newDataArray.map((item) => ({
      itemType: item.MstItemTypeId,
      itemCategoryId: item.MstCategoryId,
      itemId: item.MstNameId,
      quantity: item.Quantity,
      UOM: item.UOM,
      rate: item.Rate,
    }));

    setTableData((prevData) => [...prevData, ...formatted]);
    updateTableData(formatted);
  };

  const handleDeleteRow = (index) => {
    if (tableData.length > 1) {
      const updated = [...tableData];
      updated.splice(index, 1);
      setTableData(updated);
    }
  };

  return (
    <div className="w-full">
      <form className="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit sm:max-h-fit">
        {/* Header Inputs */}
        <div className={mainTable.grid4}>
          <InputText
            title="Receipt No"
            name="receiptno"
            content={data?.ReceiptNo || ""}
            disabled={true}
            classStar={"text-red-500"}
          />
          <InputText
            title="Receipt Date"
            name="Receiptdate"
            content={formatDate(data?.ReceiptDate ?? "").split("T")[0]}
            disabled={true}
            classStar={"text-red-500"}
          />
          <InputText
            title="Received From"
            name="receivedFrom"
            content={data?.ReceivedFrom || ""}
            disabled={true}
            classStar={"text-red-500"}
          />
          <InputText
            title="Received By"
            name="receivedBy"
            content={data?.ReceivedBy || ""}
            disabled={true}
            classStar={"text-red-500"}
          />
        </div>

        {/* Table */}
        <div className="w-full max-h-[400px] overflow-auto mt-6">
          <table className="w-full border border-gray-300">
            <thead className="bg-[#3D6643] text-white sticky top-0 z-10">
              <tr>
                <th className="border px-2 py-2 w-[30px]">SN</th>
                <th className="border px-4 py-2 w-[200px]">Item Type</th>
                <th className="border px-4 py-2 w-[200px]">Category</th>
                <th className="border px-4 py-2 w-[230px]">Name</th>
                <th className="border px-4 py-2 w-[90px]">Quantity</th>
                <th className="border px-4 py-2 w-[100px]">U.O.M</th>

                <th className="border px-4 py-2 w-[100px]">Rate</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr key={index}>
                  <td className="border px-1 py-2 text-center">{index + 1}</td>

                  <td className="border px-2 py-2">
                    <AutoDropDown
                      name="itemtype"
                      Class="custom-class"
                      disabled={true}
                      options={itemtype || []}
                      selectedOption={
                        row.itemType
                          ? itemtype.find((x) => x.value == row.itemType)
                          : ""
                      }
                      placeholder="Select"
                    />
                  </td>

                  <td className="border px-2 py-2">
                    <AutoDropDown
                      name="itemcategory"
                      Class="custom-class"
                      disabled={true}
                      options={row.itemCategoryList || []}
                      selectedOption={
                        row.itemCategoryId
                          ? row.itemCategoryList.find(
                              (x) => x.value === row.itemCategoryId
                            )
                          : ""
                      }
                      placeholder="Select"
                    />
                  </td>

                  <td className="border px-2 py-2">
                    <AutoDropDown
                      name="itemname"
                      Class="custom-class"
                      disabled={true}
                      options={row.itemList || []}
                      selectedOption={
                        row.itemId
                          ? row.itemList.find((x) => x.value == row.itemId)
                          : ""
                      }
                      placeholder="Select"
                    />
                  </td>
                  <td className="border px-2 py-2">
                    <InputText
                      inputType="number"
                      name="quantity"
                      content={row.quantity}
                      disabled={true}
                    />
                  </td>
                  <td className="border px-2 py-2">
                    <InputText
                      inputType="text"
                      name="uom"
                      content={row.uomId}
                      disabled={true}
                    />
                  </td>

                  <td className="border px-4 py-2">
                    <InputText name="rate" content={row.rate} disabled={true} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Remarks */}
        <div className="mt-4">
          <TextArea
            title="Remarks"
            name="remarks"
            content={data?.Remarks || ""}
            rows="4"
            disabled={true}
            maxlength={500}
          />
        </div>
      </form>
    </div>
  );
};

export default ReceiptMainPopup;
